import React, { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link as LinkExternal } from "@bwevents/components";
import {
  faBars,
  faBookmark,
  faHandshakeAngle,
  faHandWave,
  faMessageSmile,
  faUser,
  faUsers,
  faXmark,
  faSquareTerminal,
  faStars,
  faRectanglePro,
  faPenNib,
  faCheckDouble,
} from "@fortawesome/pro-regular-svg-icons";
import { Dialog } from "primereact/dialog";
import logo from "../../assets/logo.png";
import DialogInterest from "../DialogInterest";
import "./Header.scss";

export default function Header({ api, account, messenger, setAccount }) {
  const { pathname } = useLocation();
  const nameUser = account ? account.first_name + " " + account.last_name : "";
  const [hasUser, setHasUser] = useState(false);
  const items = [
    {
      label: "Home",
      link: "/",
      isExternal: false,
      icon: "",
    },
    {
      label: "Company",
      items: [
        {
          label: "About",
          isExternal: true,
          icon: (
            <FontAwesomeIcon icon={faHandWave} style={{ color: "#ffffff" }} />
          ),
          link: "https://bweventstech.com/about/",
        },
        {
          label: "Our Team",
          isExternal: true,
          icon: <FontAwesomeIcon icon={faUsers} style={{ color: "#ffffff" }} />,
          link: "https://bweventstech.com/our-team/",
        },
        {
          label: "Partners & Vendors",
          isExternal: true,
          icon: (
            <FontAwesomeIcon
              icon={faHandshakeAngle}
              style={{ color: "#ffffff" }}
            />
          ),
          link: "https://bweventstech.com/partners-vendors/",
        },
      ],
    },
    {
      label: "Solutions",
      items: [
        {
          label: "Event Tech Consulting",
          isExternal: true,
          icon: (
            <FontAwesomeIcon
              icon={faMessageSmile}
              style={{ color: "#ffffff" }}
            />
          ),
          link: "https://bweventstech.com/event-tech-consulting/",
        },
        {
          label: "Platform Management and Implementation",
          isExternal: true,
          icon: (
            <FontAwesomeIcon
              icon={faSquareTerminal}
              style={{ color: "#ffffff" }}
            />
          ),
          link: "https://bweventstech.com/platform-management-and-implementation/",
        },
        {
          label: "Custom Solutions & Development",
          isExternal: true,
          icon: <FontAwesomeIcon icon={faStars} style={{ color: "#ffffff" }} />,
          link: "https://bweventstech.com/custom-solutions-development/",
        },
        {
          label: "On-Site Event Tech Management",
          isExternal: true,
          icon: (
            <FontAwesomeIcon
              icon={faRectanglePro}
              style={{ color: "#ffffff" }}
            />
          ),
          link: "https://bweventstech.com/custom-solutions-development/",
        },
      ],
    },
    {
      label: "Resources",
      items: [
        {
          label: "Blog",
          isExternal: true,
          icon: (
            <FontAwesomeIcon icon={faPenNib} style={{ color: "#ffffff" }} />
          ),
          link: "https://bweventstech.com/blog",
        },
        {
          label: "Case Studies",
          isExternal: true,
          icon: (
            <FontAwesomeIcon
              icon={faCheckDouble}
              style={{ color: "#ffffff" }}
            />
          ),
          link: "https://bweventstech.com/case-study",
        },
      ],
    },
    {
      label: "Contact",
      isExternal: true,
      link: "https://bweventstech.com/contact/",
      icon: "",
    },
    // {
    //   label: "Engagement Portal",
    //   isExternal: false,
    //   link: "/event-center",
    //   icon: "",
    // },
  ];
  const [menuOpen, setMenuOpen] = useState(false);
  const [subMenuOpen, setSubMenuOpen] = useState("");

  const [dialogInterests, setDialogInterests] = useState(false);
  const [hideDialog, setHideDialog] = useState(false);

  const getAcronyms = () => {
    let names = nameUser.split(" "),
      initials = names[0].substring(0, 1).toUpperCase();

    if (names.length > 1) {
      initials += names[names.length - 1].substring(0, 1).toUpperCase();
    }
    return initials;
  };
  const openMenu = () => {
    setMenuOpen(true);
    document.body.style.overflow = "hidden";
  };
  const closeMenu = () => {
    setMenuOpen(false);
    setSubMenuOpen("");
    document.body.style.overflow = "";
  };
  const openSubMenu = (value) => {
    if (value === subMenuOpen) {
      setSubMenuOpen("");
    } else {
      setSubMenuOpen(value);
    }
  };

  const getCheckHideDialogInterests = (e) => {
    setHideDialog(e);
  };
  const closeDialogInterests = () => {
    setDialogInterests(false);
    let typeHide = "updateLogin";
    if (hideDialog) {
      typeHide = "never";
    }
    localStorage.setItem(btoa("hideDialog"), btoa(typeHide));
  };
  const logout = () => {
    const showDialog = localStorage.getItem(btoa("hideDialog"));
    if (atob(showDialog) === "updateLogin") {
      localStorage.removeItem(btoa("hideDialog"));
    }
    api("api/users/logout/", {
      method: "POST",
      body: {
        client_id: process.env.REACT_APP_CLIENT_ID,
      },
    }).then(({ ok }) => {
      if (ok) {
        window.location.href = "/";
      }
    });
  };
  const userPicture = () => {
    return account && account.profile_image_url ? (
      <img src={account.profile_image_url} alt={getAcronyms()} />
    ) : (
      <span>{getAcronyms()}</span>
    );
  };

  useEffect(() => {
    const userExist = !!(account && account.id);

    if (pathname !== "/profile" && !!account) {
      const existingValues =
        !!account.topics.some((topic) => topic.check) ||
        (account.other_interests && account.other_interests.length);

      const showDialog = !existingValues
        ? !localStorage.getItem(btoa("hideDialog")) ||
          atob(localStorage.getItem(btoa("hideDialog"))) === ""
        : false;
      if (userExist) setDialogInterests(showDialog);
    }
    setHasUser(userExist);
  }, [setHasUser, account, pathname]);

  return (
    <header>
      <div className="bw-event-container">
        <nav>
          <Link to="/" className="bw-event-logo" onClick={closeMenu}>
            <img src={logo} alt="Event Tech" />
          </Link>
          <div className={"bw-event-menu " + (menuOpen ? "open" : "")}>
            <div className="bw-event-backdrop" onClick={closeMenu}></div>
            <ul>
              {hasUser ? (
                <li className="mobile">
                  <NavLink
                    className={({ isActive, isPending }) =>
                      isPending ? "pending" : isActive ? "active" : ""
                    }
                    exact="true"
                    to="/profile"
                    onClick={closeMenu}
                  >
                    Profile
                  </NavLink>
                </li>
              ) : null}
              {items.map((menu, key) =>
                menu.items ? (
                  <li key={key + menu.label} className={"bw-event-li-dropdown"}>
                    <button
                      className={"bw-event-btn-dropdown-menu"}
                      onClick={() => openSubMenu(menu.label.toLowerCase())}
                    >
                      {menu.icon ? menu.icon : ""} {menu.label}
                    </button>
                    <ul
                      className={
                        "bw-event-dropdown-menu " +
                        (subMenuOpen === menu.label.toLowerCase() ? "open" : "")
                      }
                    >
                      {menu.items.map((submenu, subkey) => (
                        <li key={subkey + menu.label + submenu.label}>
                          {submenu.isExternal ? (
                            <LinkExternal
                              href={submenu.link}
                              onClick={closeMenu}
                            >
                              {submenu.icon ? submenu.icon : ""}
                              {submenu.label}
                            </LinkExternal>
                          ) : (
                            <NavLink
                              activeClassName="is-active"
                              className={({ isActive, isPending }) =>
                                isPending ? "pending" : isActive ? "active" : ""
                              }
                              to={submenu.link}
                              onClick={closeMenu}
                            >
                              {submenu.icon ? submenu.icon : ""}
                              {submenu.label}
                            </NavLink>
                          )}
                        </li>
                      ))}
                    </ul>
                  </li>
                ) : (
                  <li key={key + menu.label}>
                    {menu.isExternal ? (
                      <LinkExternal href={menu.link} onClick={closeMenu}>
                        {menu.icon ? menu.icon : ""}
                        {menu.label}
                      </LinkExternal>
                    ) : (
                      <NavLink
                        className={({ isActive, isPending }) =>
                          isPending ? "pending" : isActive ? "active" : ""
                        }
                        to={menu.link}
                        onClick={closeMenu}
                      >
                        {menu.icon ? menu.icon : ""}
                        {menu.label}
                      </NavLink>
                    )}
                  </li>
                ),
              )}
              {hasUser ? (
                <li className="mobile">
                  <button onClick={logout}>Logout</button>
                </li>
              ) : null}
            </ul>
          </div>
          <div className="bw-event-actions">
            <div className="btns-check-user">
              {hasUser ? (
                <>
                  <NavLink
                    className="bw-event-btn bw-event-btn-favorite"
                    to="/profile?tab=favorite"
                  >
                    <FontAwesomeIcon
                      className="not-favorite"
                      icon={faBookmark}
                      style={{ color: "#ffffff" }}
                    />
                    <p>Favorites</p>
                    <span>{(account && account.favorite_count) || 0}</span>
                  </NavLink>
                  <div className="bw-event-user-dropdown mobile">
                    <button className={"bw-event-btn bw-event-btn-profile"}>
                      {userPicture()}
                    </button>
                  </div>
                  <div className="bw-event-user-dropdown desktop">
                    <button
                      className={"bw-event-btn bw-event-btn-profile"}
                      onClick={() => openSubMenu("logged")}
                    >
                      {userPicture()}
                    </button>
                    <ul
                      className={
                        "bw-event-user-dropdown-menu " +
                        (subMenuOpen === "logged" ? "open" : "")
                      }
                    >
                      <li>
                        <NavLink
                          className={({ isActive, isPending }) =>
                            isPending ? "pending" : isActive ? "active" : ""
                          }
                          to="/profile"
                          onClick={closeMenu}
                        >
                          Profile
                        </NavLink>
                      </li>
                      <li>
                        <button onClick={logout}>Logout</button>
                      </li>
                    </ul>
                  </div>
                </>
              ) : (
                <Link to="/login" className="bw-event-btn bw-event-btn-login">
                  <FontAwesomeIcon icon={faUser} style={{ color: "#ffffff" }} />
                  <span>Sign in</span>
                </Link>
              )}
            </div>
            <LinkExternal
              href="https://bweventstech.com/contact/"
              className="bw-event-btn bw-event-btn-chat"
            >
              Let’s chat!
            </LinkExternal>
            <button className="bw-event-btn bw-event-btn-menu">
              {!menuOpen ? (
                <FontAwesomeIcon
                  icon={faBars}
                  style={{ color: "#ffffff" }}
                  onClick={openMenu}
                />
              ) : (
                <FontAwesomeIcon
                  icon={faXmark}
                  style={{ color: "#ffffff" }}
                  onClick={closeMenu}
                />
              )}
            </button>
          </div>
        </nav>
      </div>
      <Dialog
        className="bw-event-dialog bw-event-dialog-interest"
        position={"top-right"}
        visible={dialogInterests}
        onHide={() => closeDialogInterests()}
      >
        <DialogInterest
          api={api}
          account={account}
          messenger={messenger}
          setAccount={setAccount}
          emmitCheckHideDialog={getCheckHideDialogInterests}
        />
      </Dialog>
    </header>
  );
}
